import { BorderRadiusToken, TRadius } from './radius'
import { BorderWidthToken, TWidth } from './width'

export default {
  radius: BorderRadiusToken,
  width: BorderWidthToken,
}

export type TBorder = TRadius | TWidth
